<template>
    <div>
        <div v-for="(item,index) in cate" :key="index">
            <div class="h_tt over">
                <em class="flor left">{{index+1}}F</em>
                <h2 class="left">
                    <a class="h_ha" href="javascript:;">{{item.title}}</a>
                    <!-- <em class="gray pl5 f16">MAN</em> -->
                </h2>
                <p class="right">
                    <a class="gray vline" href="javascript:;" v-for="it in item.z" :key="it.id">{{it.title}}</a>
                    <!-- <em class="vline">|</em>
                    <a class="gray" href="javascript:;">女优名器</a>
                    <em class="vline">|</em>
                    <a class="gray" href="javascript:;">性感美臀</a>
                    <em class="vline">|</em>
                    <a class="c9" href="javascript:;">延时喷剂</a>
                    <em class="vline">|</em>
                    <a href="javascript:;" class="org" rel="nofollow">更多>></a> -->
                </p>
            </div>
            <div class="h_fl">
                <div class="h_cat">
                    <h3 class="mb5">{{item.title}}</h3>
                    <a href="javascript:;" v-for="it in item.z" :key="it.id">{{it.title}}</a>
                </div>
                <a class="h_ff" href="javascript:;">
                    <img src="https://s.cccgx.com/themes/v4/css/ft/f1.jpg" width="123" height="75" alt="男性用品">
                </a>
            </div>
            <div class="h_fm">
                <a href="javascript:;">
                    <img src="../../assets/picture/category/1526551582957827911.jpg" width="400" height="390">
                </a>
            </div>
            <div class="h_fr">
                <a class="f_aa" href="javascript:;">
                    <div class="f_am">
                        <em class="red">全自动加热</em>飞机杯
                        <p>智能温控 饱满内胆</p>
                        <i>¥299</i>
                    </div>
                    <img src="../../assets/picture/category/1541992400045406432.jpg" width="160" height="170" class="ha_po">
                </a>
                <a class="f_aa" href="javascript:;">
                    <div class="f_am">
                        <em class="red">榨汁</em>小妹贝卡
                        <p>双通道带胸名器</p>
                        <i>¥168</i>
                    </div>
                    <img src="../../assets/picture/category/20210910062948_18973.jpg" width="160" height="170" class="ha_po">
                </a>
                <a class="f_aa" href="javascript:;">
                    <div class="f_am">
                        <em class="red">高速活塞</em>全自动飞机杯
                        <p>豪华配置 静音抽送</p>
                        <i>¥499</i>
                    </div>
                    <img src="../../assets/picture/category/1499250973569998038.jpg" width="160" height="170" class="ha_po">
                </a>
                <a class="f_aa" href="javascript:;">
                    <div class="f_am">
                        <em class="red">夜樱</em>后庭自慰器
                        <p>智能加热 无线遥控</p>
                        <i>¥249</i>
                    </div>
                    <img src="../../assets/picture/category/1510033418619905365.jpg" width="160" height="170" class="ha_po">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //全部商品分类
            cate: [],
            type: 1,
            list:[],
        }
    },
    mounted() {
        this.getShopCate();
        this.getShopProduct();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.data.code == 200) {
                    this.cate = [];
                    var arr = res.data.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
                    });
                    this.type = res.data.result.types;
                }
            });
        },
        //获取分类商品
        getShopProduct(){
            this.$api.getProduct.getShopProduct({}).then(res => {
                if(res.data.code == 200){
                    this.list = [];
                    console.log(res.data);
                }
            });
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/common-index.vue